import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/service/course.service';
import { ModuloService } from 'src/app/service/modulo.service';
import { ActivatedRoute } from '@angular/router';
import { Corso } from 'src/app/model/corso';
import { CorsoModulo } from 'src/app/model/corsomodulo';
import { first } from 'rxjs/internal/operators/first';

@Component({
  selector: 'app-esercitazioni-modulo',
  templateUrl: './esercitazioni-modulo.component.html',
  styleUrls: ['./esercitazioni-modulo.component.css']
})
export class EsercitazioniModuloComponent implements OnInit {

    corso: Corso;
    moduli: Array<CorsoModulo>;
    moduloParentsStruct: Array<CorsoModulo>;
    checkEsercitazioni = false;

    constructor(
        private route: ActivatedRoute,
        private courseSrv: CourseService,
        private moduloSrv: ModuloService
    ) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params =>  {
            const corsoId = +params.get('courseId');
            const moduloId = +params.get('moduloId');
            this.loadCorso(corsoId);
            this.loadModuliWithEsercitazioni(corsoId, moduloId);
            this.loadModuloParentsStruct(moduloId);
        });
    }

    private loadCorso(courseId: number) {
        this.courseSrv.getCourse(courseId)
        .pipe(first())
            .subscribe(
                data => {
                    this.corso = data;
                },
                error => {
                    return;
                }
            );
    }

    private loadModuliWithEsercitazioni(courseId: number, moduloId: number) {
        this.moduloSrv.getModuliWithEsercitazioni2(courseId, moduloId)
        .pipe(first())
            .subscribe(
                data => {
                    this.moduli = data;
                    this.checkForEsercitazioni(this.moduli);
                },
                error => {
                    return;
                }
            );
    }

    private loadModuloParentsStruct(moduloId: number) {
        this.moduloSrv.getModuleParentsStruct(moduloId)
        .pipe(first())
            .subscribe(
                data => {
                    this.moduloParentsStruct = data;
                },
                error => {
                    return;
                }
            );
    }

    private checkForEsercitazioni(moduli: Array<CorsoModulo>) {
        this.checkEsercitazioni = false;
        moduli.forEach(modulo => {
            if (modulo.esercitazioni != null && modulo.esercitazioni.length > 0) {
                this.checkEsercitazioni = true;
                return;
            }
        });
    }

}
